export function isAndroidOriOS() {
    return isAndroid() || isIOS();
}

export function isAndroid() {
    return navigator.userAgent.match(/Android/i);
}

export function isIOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

export function isMobileApp() {
    return navigator.userAgent.indexOf('gonative') > -1;
}

export const isIphoneWithFaceId = () => {
    if (navigator.userAgent.match(/(iPhone)/)) {
        if (screen.availWidth === 375 && screen.availHeight === 812) return true;
        // iphone X
        else if (screen.availWidth === 414 && screen.availHeight === 896) return true;
        else if (screen.availWidth === 390 && screen.availHeight === 844) return true;
        else if (screen.availWidth === 360 && screen.availHeight === 780) return true;
        else if (screen.availWidth === 428 && screen.availHeight === 926) return true;
        else if (screen.availWidth === 375 && screen.availHeight === 667) return false;
        // viewport iPhone 8
        else if (screen.availWidth === 414 && screen.availHeight === 736) return false;
        // viewport iPhone 8 plus
        else if (screen.availWidth === 476 && screen.availHeight === 847) return false;
    }
    return false;
};

export const getAppLink = () => {
    const gPlay = 'https://play.google.com/store/apps/details?id=ai.raison.app';
    const appStore = 'https://apps.apple.com/us/app/raison-ai/id1444995068';
    return isAndroid() ? gPlay : appStore;
};
